import React, { useEffect, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export type TaxType = {
  id: string;
  code: string;
  name: string;
  description: string;
  isActive: boolean;
};
interface TaxTypeSelectorProps {
  value: string;
  onChange: (taxTypeId: string, taxType: TaxType | null) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  taxTypes?: TaxType[];
}
export function TaxTypeSelector({
  value,
  onChange,
  label = 'Tax Type',
  placeholder = 'Select tax type',
  required = false,
  error,
  disabled = false,
  taxTypes = []
}: TaxTypeSelectorProps) {
  // Filter to only show active tax types
  const availableTaxTypes = taxTypes.filter(tt => tt.isActive);
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    const selectedTaxType = taxTypes.find(tt => tt.id === selectedId) || null;
    onChange(selectedId, selectedTaxType);
  };
  return <div data-id="element-12686">
      <label htmlFor="taxType" className="block text-sm font-medium text-gray-700" data-id="element-12687">
        {label} {required && <span className="text-red-500" data-id="element-12688">*</span>}
      </label>
      <div className="mt-1 relative" data-id="element-12689">
        <select id="taxType" value={value} onChange={handleChange} disabled={disabled} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${error ? 'border-red-300' : ''} ${disabled ? 'bg-gray-50 cursor-not-allowed' : ''}`} data-id="element-12690">
          <option value="" data-id="element-12691">{placeholder}</option>
          {availableTaxTypes.map(taxType => <option key={taxType.id} value={taxType.id} data-id="element-12692">
              {taxType.code} - {taxType.name}
            </option>)}
        </select>
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-12693">{error}</p>}
      </div>
      {value && <p className="mt-1 text-xs text-gray-500" data-id="element-12694">
          {availableTaxTypes.find(tt => tt.id === value)?.description}
        </p>}
    </div>;
}